import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Icon } from 'components/Icons'
import styles from './CurrentNotifications.module.scss'

export const requestNotificationRead = ids => {
  for (let index = 0; index < ids.length; index += 100) window.dispatchEvent(new CustomEvent('chu:notifications-read', { detail: ids.slice(index, index + 100) }))
}

export function notificationDestination(link) {
  const value = String(link || '').replace(/^\//, '')
  if (!value || /^(https?:|javascript:|\/)/i.test(value)) return null
  const match = value.match(/^(task|subtask|statement)\/(\d+)\/?$/)
  return match ? { path: `/${match[1]}/`, state: { usedId: match[2] } } : { path: `/${value}` }
}

export default function CurrentNotifications() {
  const items = useSelector(state => state.alert.alerts || [])
  const status = useSelector(state => state.alert.notificationStatus)
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  useEffect(() => {
    if (!open) return undefined
    const close = event => { if (event.key === 'Escape' || (event.type === 'mousedown' && !ref.current?.contains(event.target))) setOpen(false) }
    document.addEventListener('mousedown', close); document.addEventListener('keydown', close)
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', close) }
  }, [open])
  const click = item => {
    if (status === 'connected') requestNotificationRead([item.id])
    const destination = notificationDestination(item.link || item.ssylca)
    if (destination) navigate(destination.path, { state: destination.state })
    setOpen(false)
  }
  return <div className={styles.wrapper} ref={ref}>
    <button type="button" className={styles.bell} aria-label={items.length ? `Уведомления: ${items.length} непрочитанных` : 'Уведомления'} aria-expanded={open} aria-controls="current-notifications" onClick={() => setOpen(value => !value)}><Icon name="bell" size={18} />{items.length > 0 && <span className={styles.count}>{items.length > 99 ? '99+' : items.length}</span>}</button>
    {open && <section id="current-notifications" className={styles.panel} aria-label="Непрочитанные уведомления"><header><strong>Уведомления</strong>{items.length > 0 && <button type="button" disabled={status !== 'connected'} onClick={() => requestNotificationRead(items.map(item => item.id))}>Прочитать все</button>}</header>
      {status !== 'connected' && <p className={styles.connection} role="status">{['forbidden', 'unauthorized'].includes(status) ? 'Соединение с уведомлениями недоступно.' : 'Подключаем уведомления…'}</p>}
      <div className={styles.list}>{items.length ? items.map(item => <button type="button" className={styles.item} key={item.id} onClick={() => click(item)}><span className={styles.dot} /><div><p>{item.message}</p><small>{item.sender_name || 'Чуйский университет'}{item.created_at && ` · ${new Date(item.created_at).toLocaleString('ru-RU', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}`}</small></div></button>) : <div className={styles.empty}><Icon name="check-circle" size={28} /><strong>Всё прочитано</strong><p>Новые события появятся здесь.</p></div>}</div>
    </section>}
  </div>
}
